import jwtDecode from 'jwt-decode';

export const getUser = () => {
  try {
    const user = jwtDecode(localStorage.sauth);
    return user;
  } catch {
    return false;
  }
};

export const isAuthenticated = () => {
  try {
    const user = jwtDecode(localStorage.sauth);
    console.log(user);
    return Date.now() < user.exp * 1000;
  } catch {
    return false;
  }
};

// Validate token from authToken field
export const isValidAuthToken = () => {
  try {
    const token = localStorage.authToken;
    if (!token) return false;
    
    const decoded = jwtDecode(token);
    if (decoded.exp && Date.now() >= decoded.exp * 1000) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
};


